import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["duration"]
  static values = { startedAt: String }

  connect() {
    this.startedAt = Date.parse(this.startedAtValue)
    if (Number.isNaN(this.startedAt)) return

    this.update()
    const elapsedMilliseconds = Math.max(0, Date.now() - this.startedAt)
    const millisecondsUntilNextMinute = 60_000 - (elapsedMilliseconds % 60_000)
    this.timeout = window.setTimeout(() => {
      this.update()
      this.interval = window.setInterval(() => this.update(), 60_000)
    }, millisecondsUntilNextMinute)
  }

  disconnect() {
    window.clearTimeout(this.timeout)
    window.clearInterval(this.interval)
  }

  update() {
    const elapsedSeconds = Math.max(0, Math.floor((Date.now() - this.startedAt) / 1000))
    this.durationTarget.textContent = this.format(elapsedSeconds)
  }

  format(totalSeconds) {
    const totalMinutes = Math.floor(totalSeconds / 60)
    const hours = Math.floor(totalMinutes / 60)
    const minutes = totalMinutes % 60

    return `${hours}:${String(minutes).padStart(2, "0")}`
  }
}
